import composeReducers from '../composeReducers';
import demandeCredit from './demandeCredit';
import demandeCreditValidation from './demandeCreditValidation';
import demandeCreditBehaviour from './demendeCreditBehaviour';
export default composeReducers(demandeCreditBehaviour, demandeCreditValidation, demandeCredit);
